import React, {useEffect, useRef, useState} from "react";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";
import useOutsideClick from "../../utilities/helperHooks";

const Select4 = (props) => {

  const {selectItems, selectedItem, selectItemClick, maxItems, label} = props;
  const [opened, setOpened] = useState(false);
  const selectElement = useRef(null);

  useOutsideClick(selectElement, () => {
    setOpened(false);
  });

  const handleSelectItemClick = (selectItem) => {
    selectItemClick(selectItem);
    setOpened(false);
  };

  const selectItemHeight = 33;
  const styles = {
    height: opened
      ? maxItems && (selectItems.length > maxItems)
        ? (maxItems * selectItemHeight) + "px"
        : (selectItems.length * selectItemHeight) + "px"
      : 0
  }

  return (
    <div className={"select4 " + props.className + (opened ? " select4--active" : "")} ref={selectElement}>
      <div className="select4-value" onClick={() => setOpened(!opened)}>
        <span className="select4-value__selected">
          {label ? label : null}<FormattedMessage id={selectedItem.text}/>
        </span>
      </div>
      <div className="select4-dropdown" style={styles}>
        <ul className={"select4-dropdown__list" + (maxItems ? " select4-dropdown__list--scroll" : "")}>
          {selectItems.map((selectItem, selectItemIndex) => {
            return (
              <li className="select4-dropdown__list-item"
                  key={selectItem.text + selectItemIndex}
                  onClick={() => handleSelectItemClick(selectItem)}>
                {label ? label : null}<FormattedMessage id={selectItem.text}/>
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
};

Select4.propTypes = {
  selectItems: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string.isRequired, // intlKey
    value: PropTypes.any.isRequired,
  })).isRequired,
  selectItemClick: PropTypes.func.isRequired,
  selectedItem: PropTypes.object,
  className: PropTypes.string,
  maxItems: PropTypes.number,
  label: PropTypes.string,
};

export default Select4
